<template>
  <v-col cols="12">
    <v-data-table
      :headers="headers"
      :items="branches"
      sort-by="id"
      class="elevation-1"
    >
      <template #top>
        <v-toolbar flat>
          <v-toolbar-title>Standorte</v-toolbar-title>
          <v-divider class="mx-4" inset vertical />
          <v-spacer />
          <v-dialog v-model="dialog" max-width="800px">
            <template #activator="{ on, attrs }">
              <v-btn
                color="primary"
                dark
                class="mb-2"
                v-bind="attrs"
                v-on="on"
              >
                Standort hinzufügen
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-tabs
                  v-model="editTab"
                  color="primary"
                  slider-color="primary"
                >
                  <v-tab ripple>
                    Daten
                  </v-tab>
                  <v-tab v-if="editedIndex != -1 && $page.props.user.permissions.offer.admin_view" ripple>
                    Verknüpfungen
                  </v-tab>
                  <v-tab ripple>
                    DSL
                  </v-tab>
                  <v-tab-item>
                    <v-card flat>
                      <v-card-text>
                        <v-container>
                          <v-row>
                            <v-col cols="6">
                              <v-text-field
                                v-model="branchForm.name"
                                :error-messages="branchForm.errors.name"
                                label="Name"
                              />
                            </v-col>
                            <!-- <v-col cols="6">
                              <v-text-field
                                v-model="branchForm.short_name"
                                :error-messages="branchForm.errors.short_name"
                                label="kurzer Name"
                              />
                            </v-col> -->
                            <v-col cols="10">
                              <v-text-field
                                v-model="branchForm.address.street"
                                :error-messages="branchForm.errors.address ? branchForm.errors.address.street : ''"
                                label="Straße"
                              />
                            </v-col>
                            <v-col cols="2">
                              <v-text-field
                                v-model="branchForm.address.house_number"
                                :error-messages="branchForm.errors.address ? branchForm.errors.address.house_number : ''"
                                label="Hausnummer"
                              />
                            </v-col>
                            <v-col cols="4">
                              <v-text-field
                                v-model="branchForm.address.zip"
                                :error-messages="branchForm.errors.address ? branchForm.errors.address.zip : ''"
                                label="PLZ"
                              />
                            </v-col>
                            <v-col cols="8">
                              <v-text-field
                                v-model="branchForm.address.city"
                                :error-messages="branchForm.errors.address ? branchForm.errors.address.city : ''"
                                label="Stadt"
                              />
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>

                      <v-card-actions>
                        <v-btn color="secondary" text @click="close">
                          abbrechen
                        </v-btn>
                        <v-spacer />
                        <v-btn color="primary" :loading="branchForm.processing" @click="save">
                          speichern
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item v-if="editedIndex != -1">
                    <v-card>
                      <v-card-text>
                        <v-list
                          subheader
                          one-line
                        >
                          <v-subheader>Ansprechpartner</v-subheader>
                          <v-list-item
                            v-for="contactPerson in branches.find(branch => branch.id == editedIndex).contact_persons"
                            :key="contactPerson.id"
                          >
                            <v-list-item-content>
                              <v-list-item-title>{{ contactPerson.first_name }} {{ contactPerson.last_name }}</v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                          <v-divider />
                          <v-subheader>Details & Angebote</v-subheader>
                          <v-list-item
                            v-for="detail in branches.find(branch => branch.id == editedIndex).offer_data_details"
                            :key="detail.id"
                          >
                            <v-list-item-content>
                              <v-list-item-title v-if="detail.offer_data.offer">
                                Angebot {{ detail.offer_data.offer.id }}
                              </v-list-item-title>
                              <v-list-item-title v-else>
                                vorläufiges Angebot {{ detail.offer_data.id }}
                              </v-list-item-title>
                              <v-list-item-subtitle>Detail-ID: {{ detail.id }}</v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item>
                    <v-card>
                      <v-card-text>
                        <dsl-form :loading="submitting" :form-data="dslForm" @submit="submitDsl" />
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                </v-tabs>
              </v-card-text>
            </v-card>
          </v-dialog>
          <v-dialog v-model="deleteDialog" max-width="500px">
            <v-card>
              <v-card-title
                class="headline"
              >
                Soll dieser Standort wirklich gelöscht werden?
              </v-card-title>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  color="blue darken-1"
                  text
                  @click="closeDelete"
                >
                  Cancel
                </v-btn>
                <v-btn
                  color="blue darken-1"
                  text
                  :loading="branchForm.processing"
                  @click="deleteItemConfirm"
                >
                  OK
                </v-btn>
                <v-spacer />
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>

      <template #[`item.actions`]="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)">
          mdi-pencil
        </v-icon>
        <v-icon small @click="deleteItem(item)">
          mdi-delete
        </v-icon>
      </template>
      <template #no-data>
        Keine Ansprechpartner gefunden.
      </template>
    </v-data-table>
  </v-col>
</template>

<script>
import DslForm from './DslForm.vue'
export default {
   components: {
      DslForm
   },
   props: {
      branches: {
         type: Array,
         required: true
      },
      company: {
         type: Object,
         required: true
      },
   },
   data () {
      return {
         dialog: false,
         deleteDialog: false,
         editTab: 0,
         headers: [
            // { text: '#', value: 'id' },
            { text: 'Name', value: 'name' },
            { text: 'Straße', value: 'address.street' },
            { text: 'Hausnummer', value: 'address.house_number' },
            { text: 'Stadt', value: 'address.city' },
            // { text: 'Land', value: 'address.country' },
            { text: 'Actions', value: 'actions', sortable: false },
         ],
         editedIndex: -1,
         branchForm: this.$inertia.form({
            name: null,
            short_name: null,
            address: {
               street: null,
               house_number: null,
               zip: null,
               city: null,
            },
         }),
         dslForm: this.$inertia.form({
            portNumber: '',
            customerNumber: '',
            accessNumber: '',
            password: ''
         }),
         submitting: false
      }
   },
   computed: {
      formTitle () {
         return this.editedIndex === -1 ? 'Standort hinzufügen' : 'Standort bearbeiten'
      },
   },

   watch: {
      dialog (val) {
         val || this.close()
      },
      deleteDialog (val) {
         val || this.closeDelete()
      },
      'branchForm.recentlySuccessful' (val) {
         if (val) {
            this.close()
            this.closeDelete()
            this.reset()
         }
      },
   },
   methods: {
      editItem (item) {
         this.editedIndex = item.id

         this.branchForm.name = item.name
         this.branchForm.short_name = item.short_name
         this.branchForm.address.street = item.address.street
         this.branchForm.address.house_number = item.address.house_number
         this.branchForm.address.zip = item.address.zip
         this.branchForm.address.city = item.address.city

         this.dslForm.portNumber = item.dsl !== null ? item.dsl.portNumber : null
         this.dslForm.customerNumber = item.dsl !== null ? item.dsl.customerNumber : null
         this.dslForm.accessNumber = item.dsl !== null ? item.dsl.accessNumber : null
         this.dslForm.password = item.dsl !== null ? item.dsl.password : null

         this.dialog = true
      },

      deleteItem (item) {
         this.editedIndex = item.id

         this.branchForm.name = item.name
         this.branchForm.short_name = item.short_name
         this.branchForm.address.street = item.address.street
         this.branchForm.address.house_number = item.address.house_number
         this.branchForm.address.zip = item.address.zip
         this.branchForm.address.city = item.address.city

         this.deleteDialog = true
      },

      deleteItemConfirm () {
         this.$inertia.delete(this.route('branch.destroy', this.editedIndex))
         this.closeDelete()
      },

      close () {
         this.dialog = false
         this.$nextTick(() => {
            this.reset()
            this.editedIndex = -1
         })
      },

      closeDelete () {
         this.deleteDialog = false
         this.$nextTick(() => {
            this.reset()
            this.editedIndex = -1
         })
      },

      reset () {
         this.branchForm.name = null
         this.branchForm.short_name = null
         this.branchForm.address.street = null
         this.branchForm.address.house_number = null
         this.branchForm.address.zip = null
         this.branchForm.address.city = null

         this.branchForm.clearErrors()
      },

      save () {
         if (this.editedIndex > -1) {
            this.branchForm.patch(this.route('branch.update', this.editedIndex))
         } else {
            this.branchForm.post(this.route('branch.store', this.company.id))
         }
      },
      submitDsl (item) {
         this.submitting = true
         item.post(this.route('customer.dsl.save', this.editedIndex), {
            onSuccess: () => this.submitting = false
         })
      }
   },
}
</script>

<style>
</style>
